import { Maybe } from '@css-xp/graphtypes';
import { TassTaxIdLabelMetadataLabel, TaxId } from '@css-xp/graphtypes/src/generated-types-new';
import {
  DISPLAY_NAME_KEY,
  TAX_ID_KEY,
  TAX_LABEL,
  TAX_LABEL_STRING,
  VAT_STATUS_KEY,
} from '@atlassian/cssxp-types-billing';

export const getDefaultTaxId = (taxIds: Maybe<Maybe<TaxId>[]> | null, taxType: string) => {
  const taxId = (taxIds || []).filter((taxId) => taxId?.label === taxType);
  return taxId.length > 0 ? taxId[0]?.id : '';
};

export const getFallbackTaxId = (taxIds: Maybe<Maybe<TaxId>[]> | null) => {
  if (!taxIds?.length) return null;
  const vatNumberTaxIds = taxIds.filter((taxId) => taxId?.label === TAX_LABEL.PST);
  if (vatNumberTaxIds.length > 0) return vatNumberTaxIds[0]?.id || null;
  return taxIds[0]?.id || null;
};

export const getDefaultVatStatus = (
  taxIds: Maybe<Maybe<TaxId>[]> | null,
  labels: Maybe<TassTaxIdLabelMetadataLabel>[],
  taxType: string
) => {
  const defaultValue = labels.find((each) => each?.default === 'true')?.vatStatus;
  const taxId = (taxIds || []).filter((taxId) => taxId?.label === taxType);
  if (taxId.length > 0) {
    return taxId[0]?.metadata?.vatStatus || defaultValue;
  }
  return defaultValue;
};

interface taxIdsMapType {
  [key: string]: TaxId;
}

//any type usage: formData can be vary as per the form
export const getTaxIds = (formData: any) => {
  const taxIdKeys = Object.keys(formData).filter((key) => key.includes(TAX_LABEL_STRING) && key.includes('__'));
  const taxIdsMap: taxIdsMapType = {};
  if (taxIdKeys.length > 0) {
    taxIdKeys.forEach((key: string) => {
      const name = key.split('__');
      //@ts-ignore -> Complaining for using bracket syntax to fetch value
      const formValue = formData[key];
      if (formValue) {
        if (!taxIdsMap[name[1]]) {
          taxIdsMap[name[1]] = {
            label: name[1],
          };
        }
        switch (name[2]) {
          case VAT_STATUS_KEY: {
            taxIdsMap[name[1]] = {
              ...taxIdsMap[name[1]],
              metadata: {
                vatStatus: formValue,
              },
            };
            break;
          }
          case DISPLAY_NAME_KEY: {
            taxIdsMap[name[1]] = {
              ...taxIdsMap[name[1]],
              displayName: formValue,
            };
            break;
          }
          case TAX_ID_KEY: {
            taxIdsMap[name[1]] = {
              ...taxIdsMap[name[1]],
              id: formValue,
            };
            break;
          }
          default:
            break;
        }
      }
    });
  }
  const taxIds = Object.values(taxIdsMap).filter((each) => !!each.id);
  return taxIds;
};
